import { useCallback, useEffect, useRef } from 'react';

import { useConfluenceAnalyticsEvents } from '@confluence/analytics/entry-points/useConfluenceAnalyticsEvents.ts';

import {
	getDependencyHealthEvent,
	type DependencyHealthReporter,
} from '../dependencyHealthAnalytics.ts';

export const useDependencyHealthAnalytics = (): DependencyHealthReporter => {
	const { createEvent } = useConfluenceAnalyticsEvents();
	const analytics = useRef(createEvent);
	useEffect(() => {
		analytics.current = createEvent;
	}, [createEvent]);
	return useCallback((attributes) => {
		try {
			analytics.current(getDependencyHealthEvent(attributes)).fire();
		} catch {
			// Analytics context changes must not restart requests or change their returned data.
		}
	}, []);
};
